import React, { useState, useEffect } from "react";
import { View, Text, StyleSheet, FlatList, ScrollView, Dimensions } from "react-native"
import { useDispatch, useSelector } from "react-redux";
import styles from "../../styles";
import { global, colors } from "../../const";
import Header from "../../components/Header";
import { Loading } from "../../components";
import * as Actions from "../../action";
import localize from "../../localize";

function VillageLeaderboard({ history }) {
    const dispatch = useDispatch();
    let height = useSelector(({ setting }) => setting.height);
    const data = useSelector(({ auth }) => auth.battle_rank);
    if (global.isNative) height = Dimensions.get("screen").height;
    useEffect(() => {
        dispatch(Actions.getTopRank());
    }, [])

    const renderItem = ({ item, index }) => {
        let rowStyle = pageStyle.Rowtitle        
        if(item.owner === 1) rowStyle = pageStyle.RowBoldtitle
        return (
            <View style={[pageStyle.TBody, index%2 !== 0 && { backgroundColor: colors.lightGray }]}>

                <View style={{ width: "30%" }}>
                    <Text style={rowStyle}>{item.city_name}</Text>
                </View>

                <View style={{ width: "10%"}}>
                    <Text style={rowStyle}>{item.xp}</Text>
                </View>

                <View style={{ width: "15%"}}>
                    <Text style={rowStyle}>{item.gold_win}</Text>
                </View>

                <View style={{ width: "15%" }}>
                    <Text style={rowStyle}>{item.gold_lost}</Text>
                </View>

                <View style={{ width: "15%"}}>
                    <Text style={rowStyle}>{item.gold_net}</Text>
                </View>

                <View style={{ width: "15%" }}>
                    <Text style={rowStyle}>{item.battle_num}</Text>
                </View>

            </View>
        )
    }

    const ListEmptyComponent = () => {
        // return null
        return (
            <View style={[pageStyle.center, { height: height - 70 }]}>
                <Loading visible={!data} size={25} />
                {data && (<Text style={styles.emptyTitle}>{localize.No_result_fond}</Text>)}
            </View>
        )
    }

    const renderHeader = () => {
        return (
            <View style={pageStyle.THeader}>

                <View style={{ width: "30%"}}>
                    <Text style={pageStyle.title}>{localize.City}</Text>
                </View>

                <View style={{ width: "10%"}}>
                    <Text style={pageStyle.title}>{localize.Xp}</Text>
                </View>

                <View style={{ width: "15%"}}>
                    <Text style={pageStyle.title}>{localize.Won}</Text>
                </View>

                <View style={{ width: "15%"}}>
                    <Text style={pageStyle.title}>{localize.Lost}</Text>
                </View>

                <View style={{ width: "15%"}}>
                    <Text style={pageStyle.title}>{localize.Net}</Text>
                </View>

                <View style={{ width: "15%"}}>
                    <Text style={pageStyle.title}>{localize.Battles}</Text>
                </View>

            </View>
        )
    }

    return (
        <View style={styles.container}>
            {!global.isNative && (<Header title={localize.Village_Leaderboard} goBack={() => history.goBack()} />)}
            <ScrollView style={!global.isNative && { height: height - 70 }}>
                <FlatList
                    data={data || []}
                    renderItem={renderItem}
                    contentContainerStyle={{ paddingBottom: 5 }}
                    ListHeaderComponent={renderHeader}
                    ListEmptyComponent={ListEmptyComponent}
                    keyExtractor={(item, index) => index + ""}
                />
            </ScrollView>
        </View>
    )

}

VillageLeaderboard.navigationOptions = () => {
    return {
        title: localize.Village_Leaderboard
    }
}

export default VillageLeaderboard;

const pageStyle = StyleSheet.create({
    title: {
        fontSize: 15,
        color: colors.midnightBack,
        fontFamily: global.FONT_BOLD,
        fontWeight: "bold",
        flexWrap: "wrap",
    },
    THeader: {
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: colors.lightGray,
        padding: 5,
        borderBottomWidth: 1,
        borderColor: colors.disable
    },
    TBody: {
        flexDirection: "row",
        alignItems: "center",
        padding: 5
    },
    Rowtitle: {
        fontSize: 14,
        fontFamily: global.FONT_REGULAR,
        flexWrap: "wrap",
        color: colors.midnightBack
    },
    RowBoldtitle: {
        fontSize: 14,
        fontFamily: global.FONT_BOLD,
        flexWrap: "wrap",
        color: colors.midnightBack,
        fontWeight: "bold"
    }
})